import { Link } from "react-router-dom";
import { Phone, FileText, MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/data";

export default function StickyMobileBar() {
  return (
    <div
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#0B2545] border-t border-white/10"
      data-testid="mobile-sticky-bar"
    >
      <div className="grid grid-cols-3">
        <a
          href={BRAND.phoneHref}
          className="flex flex-col items-center justify-center py-2 gap-0.5 text-white active:bg-white/5"
          data-testid="sticky-call"
        >
          <Phone className="h-3.5 w-3.5" strokeWidth={1.8} />
          <span className="font-mono text-[9px] tracking-[0.22em] uppercase">Call</span>
        </a>
        <Link
          to="/contact"
          className="flex flex-col items-center justify-center py-2 gap-0.5 text-white border-x border-white/10 active:bg-white/5"
          data-testid="sticky-quote"
        >
          <FileText className="h-3.5 w-3.5" strokeWidth={1.8} />
          <span className="font-mono text-[9px] tracking-[0.22em] uppercase">Quote</span>
        </Link>
        <a
          href={BRAND.emailHref}
          className="flex flex-col items-center justify-center py-2 gap-0.5 text-white active:bg-white/5"
          data-testid="sticky-contact"
        >
          <MessageCircle className="h-3.5 w-3.5" strokeWidth={1.8} />
          <span className="font-mono text-[9px] tracking-[0.22em] uppercase">Email</span>
        </a>
      </div>
    </div>
  );
}
